import { Dispatch } from 'react';

import {
	setDueEndDate,
	setDueStartDate,
	setEffectiveEndDate,
	setEffectiveStartDate,
} from 'common/store/reducer/horizonScanReducer';

import { DATE_ENTITY } from 'features/HorizonScanning/HorizonScanConstants';

/**
 * @method to dispatch start date based on title provided
 */

const { DUE_DATE } = DATE_ENTITY;

export const dispatchStartDateBasedOnTitle = (
	title: string,
	startDate: Date | null,
	dispatch: Dispatch<any>,
) => {
	if (title?.toLowerCase() === DUE_DATE?.toLowerCase()) {
		dispatch(setDueStartDate(startDate));
	} else {
		dispatch(setEffectiveStartDate(startDate));
	}
};

/**
 * @method to dispatch end date based on title provided
 */
export const dispatchEndDateBasedOnTitle = (
	title: string,
	endDate: Date | null,
	dispatch: Dispatch<any>,
) => {
	if (title?.toLowerCase() === DUE_DATE?.toLowerCase()) {
		dispatch(setDueEndDate(endDate));
	} else {
		dispatch(setEffectiveEndDate(endDate));
	}
};
